export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  ctaShop: "home-cta-shop",
  ctaVerify: "home-cta-verify",
  categoryCard: "home-category-card",
};

export const NAV = {
  brand: "nav-brand",
  shop: "nav-shop",
  verify: "nav-verify",
  planet: "nav-shop-by-planet",
  purpose: "nav-shop-by-purpose",
  consultation: "nav-consultation",
  cart: "nav-cart",
  account: "nav-account",
  login: "nav-login",
  admin: "nav-admin",
};
